import { colors } from 'Constants/Colors';

export const CardContentStyle = {
  width: '90%',
  margin: 'auto',
  boxShadow: 'none',
};

export const CardContentTop = {
  background: colors.BLUE_GRAY,
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  zIndex: '1',
  padding: '1em',
  paddingBottom: '0',
};

export const ListItemStyle = { textAlign: 'justify' };

export const CardContentBack = {
  background: 'white',
  position: 'absolute',
  left: '0',
  right: '0',
  bottom: '0',
  height: '60%',
  zIndex: '-1',
};

export default {
  CardContentStyle,
  CardContentTop,
  ListItemStyle,
  CardContentBack,
};
